import { z } from 'zod';

export const ValueDurationTypes = ['MIN', 'HR', 'DAY'] as const;
export type ValueDurationType = typeof ValueDurationTypes[number];
export const SimpleDurationTypes = [
  'UNKNOWN',
  'NIL',
  'ONGOING_EPISODIC',
  'ONGOING_CONS',
] as const;
export type SimpleDurationType = typeof SimpleDurationTypes[number];
export const DurationTypes = [...ValueDurationTypes, ...SimpleDurationTypes] as const;
export const DurationTypeZod = z.enum(DurationTypes);
export type DurationType = z.infer<typeof DurationTypeZod>;

export const DurationZod = z.union([
  z.object({
    type: DurationTypeZod.extract(ValueDurationTypes),
    value: z.number().int(),
  }),
  z.object({
    type: DurationTypeZod.extract(SimpleDurationTypes),
  }),
]);
export type Duration = z.infer<typeof DurationZod>;
export type ValueDuration = Extract<Duration, { value: number }>;

export const isValueDurationType = (durationType: DurationType): durationType is ValueDurationType => {
  return ValueDurationTypes.includes(durationType as ValueDurationType);
};
export const isValueDuration = (duration: Duration): duration is ValueDuration => {
  return isValueDurationType(duration.type);
};

export const DurationTypeText: Record<DurationType, string> = {
  MIN: 'Minutes',
  HR: 'Hours',
  DAY: 'Days',
  ONGOING_EPISODIC: 'Ongoing (episodic)',
  ONGOING_CONS: 'Ongoing (continuous)',
  NIL: 'Nil',
  UNKNOWN: 'Unknown',
};

export const ValueDurationTypeTacText: Record<ValueDurationType, (value: number) => string> = {
  MIN: () => 'MIN',
  HR: () => 'HR',
  DAY: (value) => (value === 1 ? 'DAY' : 'DAYS'),
};
